/**
 * @generated SignedSource<<d6f0c7de59ba12c2b135955d133fc5d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion$data = {
  readonly storesCompletedCount: number;
  readonly storesCount: number;
  readonly " $fragmentType": "WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion";
};
export type WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion$key = {
  readonly " $data"?: WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storesCompletedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storesCount",
      "storageKey": null
    }
  ],
  "type": "RoutineWorkspaceOccasion",
  "abstractKey": null
};

(node as any).hash = "bdd74dd7adc00661fd329b609993e715";

export default node;
